import { useState } from "react";
import PdfViewer from "../components/PdfViewer";
import JsPDFExporter from "../components/JsPDFExporter";
import {
  isEmailValid,
  isNotEmpty,
  combineNames,
} from "../../util/string-helper";
import { rejectedDomains } from "../components/defaults";

const BuildMiiEmailModal = ({
  onClick,
  jobDescription,
  role,
  uId,
  value,
  emailStatus,
  setEmailStatus,
}) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    position: "",
    company: "",
    email: "",
  });

  const [emailError, setEmailError] = useState(false);
  const [firstNameError, setFirstNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);

  if (!value) return null;

  const handleCancel = () => {
    onClick(value);
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    let updatedFormData = {};

    // Update the specific field in the form data
    updatedFormData = {
      ...formData,
      [id]: value,
    };

    // Validate First Name
    if (id === "firstName") {
      setFirstNameError(!isNotEmpty(value));
    }

    // Validate Last Name
    if (id === "lastName") {
      setLastNameError(!isNotEmpty(value));
    }

    // Validate Email with domains to reject
    if (id === "email") {
      setEmailError(!isEmailValid(value));
    }

    // Finally, set the updated form data
    setFormData(updatedFormData);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
      <div className="bg-white-900 rounded-lg p-8 relative z-10 mx-2">
        <h2 className="text-2xl font-bold mb-4">Export to Email</h2>
        <p className="text-gray-600 mb-6">
          To whom should we send your Job Description to?
        </p>

        <div className="mb-4 flex">
          <div className="mr-2 w-1/2">
            <label htmlFor="firstName" className="block mb-1 font-semibold">
              First Name <span className="italic text-red-500">*</span>
            </label>
            <input
              id="firstName"
              type="text"
              value={formData.firstName}
              onChange={handleChange} // Separate handler for First Name
              className={`w-full border ${
                firstNameError ? "border-red-500" : "border-gray-300"
              } rounded px-3 py-2`}
              required
            />
            {firstNameError && (
              <p className="text-red-500 italic">First Name is required</p>
            )}
          </div>

          <div className="ml-2 w-1/2">
            <label htmlFor="lastName" className="block mb-1 font-semibold">
              Last Name <span className="italic text-red-500">*</span>
            </label>
            <input
              id="lastName"
              type="text"
              value={formData.lastName}
              onChange={handleChange} // Separate handler for Last Name
              className={`w-full border ${
                firstNameError ? "border-red-500" : "border-gray-300"
              } rounded px-3 py-2`}
              required
            />
            {lastNameError && (
              <p className="text-red-500 italic">Last Name is required</p>
            )}
          </div>
        </div>

        <div className="mb-4">
          <label htmlFor="position" className="block mb-1 font-semibold">
            Position
          </label>
          <input
            id="position"
            type="text"
            value={formData.position}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2"
          />
        </div>

        <div className="mb-4">
          <label htmlFor="company" className="block mb-1 font-semibold">
            Company
          </label>
          <input
            id="company"
            type="text"
            value={formData.company}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2"
          />
        </div>

        <div className="mb-6">
          <label htmlFor="email" className="block mb-1 font-semibold">
            Email <span className="italic text-red-500">*</span>
          </label>
          <input
            id="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            className={`w-full border ${
              emailError ? "border-red-500" : "border-gray-300"
            } rounded px-3 py-2`}
            required
          />
          {emailError && (
            <p className="text-red-500 italic">Email is invalid</p>
          )}
        </div>

        <div className="flex justify-center">
          <button
            onClick={handleCancel}
            className="mr-5 px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 text-white font-semibold rounded-full"
          >
            Cancel
          </button>
          <JsPDFExporter
            text={jobDescription}
            role={role}
            disabled={
              !isNotEmpty(formData.firstName) ||
              !isNotEmpty(formData.lastName) ||
              !isEmailValid(formData.email)
            }
            formData={formData}
            uId={uId}
            onClick={onClick}
            emailStatus={emailStatus}
            setEmailStatus={setEmailStatus}
          />
        </div>
      </div>
    </div>
  );
};

export default BuildMiiEmailModal;
